// Shared
import { getTextWidth } from '../shared/helper';

// Components
import Filter from '../components/listing/Filter/Filter';

export function salesChannelUpholsteriesListing(salesChannelID = null) {
  const endpoint = '/saleschannels/upholsteries';
  const initialSort = { field: 'componentID', sort: 'asc' };
  const initialFilters = { DescriptionSearchType: 'C' };

  const getColumns = (rows, columnsCustomized) => {
    const columns = [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        hideFromColumnsSelector: true
      },
      {
        field: 'componentID',
        headerName: 'ID',
        hide: true,
        hideFromColumnsSelector: true
      },
      { 
        field: 'description', 
        headerName: 'Type Description' 
      },
    ];

    const columnsResized = columns;

    columns.forEach((column, i) => {
      const id = column.field;
      let text = column.headerName;

      const textWidth = getTextWidth(text);
      columnsResized[i].width = textWidth;

      rows.forEach((row, j) => {
        if (row[id]) {
          let text = row[id];

          const textWidth = getTextWidth(text);

          if (columnsResized[i].width < textWidth) {
            columnsResized[i].width = textWidth;
          }
        }
      });
    });

    return columnsResized;
  };

  const getRows = (data) => {
    const rows = [];

    data.forEach((row, i) => {
      // Text/numeric values
      rows[i] = {
        id: row.componentID,
        componentID: row.componentID
      };

      // Object values
      const objects = {
        description: row.componentDescription,
      };

      // Get the text/value from the default culture
      Object.entries(objects).forEach(([j, prop]) => {
        prop.translations.forEach((culture, k) => {
          if (culture.defaultCulture === true) {
            rows[i][j] = culture.text;
          }
        });
      });
    });

    return rows;
  };

  const getFilters = () => {
    return [
      [
        {
          size: { xs: 12 },
          component: (
            <Filter type="text" parameter="Description" label="Type Description" />
          )
        }
      ]
    ];
  };

  return {
    endpoint,
    initialSort,
    initialFilters,
    getColumns: getColumns,
    getRows: getRows,
    getFilters: getFilters
  }
}